import {
  ReportStatusEnumValues,
  ReportStatusFilterOptionEnumValues,
  MarketMakerStatusEnumValues,
} from '@forgd/shared/enums'
import { MarketMakerEngagementsStatusEnumValues } from '@forgd/shared/enums'
import { z } from 'zod'

const EngagementSchema = z.object({
  id: z.string(),
  status: z.enum(MarketMakerEngagementsStatusEnumValues),
})

const ProjectSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  ticker: z.string().nullable(),
})

const MarketMakerSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
})

const MarketMakerDailyReportSchema = z.object({
  date: z.string(),
  reports: z.array(
    z.object({
      status: z.enum(ReportStatusEnumValues),
      invalidFields: z.record(z.string(), z.array(z.string())).optional(),

      project: ProjectSchema,
      engagement: EngagementSchema,
    }),
  ),
})

const MarketMakerReportsSchema = z.array(MarketMakerDailyReportSchema)

export const GetMarketMakerReportsHistoryQueryParams = z.object({
  timeframe: z.enum(['7', '30', '60', 'custom']).default('7'),
  date: z.string().date().optional(),
  projectId: z.string().uuid().optional(),
  statuses: z.enum(ReportStatusFilterOptionEnumValues).optional(),
})

export const GetMarketMakerReportsHistoryResponseBody = z.object({
  data: MarketMakerReportsSchema,
  firstReportReceivedAt: z.string().date().nullable(),
  lastReportReceivedAt: z.string().date().nullable(),
})

export const GetMarketMakersReportHistoryQueryParams = z.object({
  date: z.preprocess((val) => (typeof val === 'string' ? [val] : val), z.array(z.string().date())),
  projectId: z.string().uuid().optional(),
  statuses: z.enum(ReportStatusFilterOptionEnumValues).optional(),
  marketMakerStatus: z.enum(MarketMakerStatusEnumValues).optional(),
})

export const GetMarketMakersReportHistoryResponseBody = z.array(
  z.object({
    date: z.string(),
    reports: z.array(
      z.object({
        status: z.enum(ReportStatusEnumValues),
        invalidFields: z.record(z.string(), z.array(z.string())).optional(),
        project: ProjectSchema,
        engagement: EngagementSchema,
        marketMaker: MarketMakerSchema,
      }),
    ),
  }),
)

export const GetMarketMakerReportsStatsResponseBody = z.object({
  totalSubmittedReports: z.number().int().nonnegative(),
  reportingSince: z.string().date().nullable(),
  totalMissedReports: z.number().int().nonnegative(),
  lastMissed: z.string().date().nullable(),
  totalActiveEngagements: z.number().int().nonnegative(),
  totalInactiveEngagements: z.number().int().nonnegative(),
})
